<template>
  <div>
    <base-header v-once pageName="고객등록 편집" :popup="true"></base-header>

    <section id="wrap">
        <div class="modify-group">
            <h6>순서를 변경해보세요.</h6>
            <div class="modify-list">
              <draggable tag="ul" 
                ghost-class="ghost"
                :list="list">
                <div 
                  v-for="element in list" 
                  :key="element.itemCd"
                >{{element.itemNm}}</div>
              </draggable>
            </div>
        </div>
    </section>
    <div class="btnWrap">
        <button type="button" class="black" @click="onCancel">취소</button>
        <button type="button" class="red" @click="onSave">저장</button>
    </div>
  </div>
</template>

<script>
var draggable = () => import(/* webpackChunkName: "draggable" */ 'vuedraggable');
// import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },
  data: function data() {
    return {
      list:[],
      editable: true,
      isDragging: false,
      delayedDragging: false
    };
  },
  methods: {
    onMove({ relatedContext, draggedContext }) {
      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    onCancel() {
      if(confirm('설정 취소 하시겠습니까?')) {
        this.$router.go(this.$router.currentRoute);
      }
    },
    onSave() {
      var isSave = confirm('설정 저장 하시겠습니까?');
      if(!isSave) {
        return;
      }

      var jsonString = JSON.stringify(this.list);
      console.log(jsonString);

      var param = {};
      param.jsonString = jsonString;
      // var that = this;
      this.$api.set
      .saveMyCstmrRegSetUserInfo(param)
      .then(function (data) {
        console.log("DashboardSet.vue <api.set.saveMyCstmrRegSetUserInfo.response>",data);
        // that.$router.go(that.$router.currentRoute);
      })
      .catch(function (error) {
        alert(error.rtMsg);
      });
    }
  },
  created: function () {
    var that = this;
    this.$api.set
      .getMyCstmrRegSetUserInfo({})
      .then(function (data) {
        console.log("DashboardSet.vue <api.set.getMyCstmrRegSetUserInfo.response>",data);
        that.list = data;
      })
      .catch(function (error) {
        alert(error.rtMsg);
      });
  },
  beforeUpdate: function () {},
};
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>